import React, { useState } from "react";
import Axios from "axios";

import { ItemStateProvider } from "../../hooks";
import SourcedItemView from "./SourcedItemView";

const SourcedItem = ({
  item: initialItem,
  isFromUsersPage,
  isLeadsPage,
  type = null,
  selected = false,
  onOpen,
}) => {
  const [item, setItem] = useState(initialItem);

  const refresh = async () => {
    const response = await Axios.get(`/api/requests/${item.id}`);

    setItem({
      ...item,
      ...response.data,
    });
  };

  return (
    <ItemStateProvider item={item}>
      <SourcedItemView
        {...{
          item,
          refresh,
          isFromUsersPage,
          isLeadsPage,
          type,
          selected,
          onOpen,
        }}
      />
    </ItemStateProvider>
  );
};

export default SourcedItem;
